module.exports = __webpack_public_path__ + "img/pageNotFound.b17ed2f5.svg";